import Vue from "vue";
import Vuex, { StoreOptions, ActionTree, MutationTree } from "vuex";
import {
    serviceProviders,
    IServiceProviderState,
    getDefaultSPState,
} from "@/store/modules/service-providers/index";
import {
    contentProviders,
    IContentProviderState,
    getDefaultCPState,
} from "@/store/modules/content-providers/index";
import {
    IUserProfileState,
    userProfile,
    getDefaultUserState,
} from "@/store/modules/user-profile/index";
import VuexPersistence from "vuex-persist";
import { NamespacesModules } from "./enums";
import {
    IProvidersUsersState,
    providersUsers,
    getDefaultProvidersUsersState,
} from "@/store/modules/providers-users";
import {
    IServiceAccountsState,
    serviceAccounts,
    getDefaultSAState,
} from "@/store/modules/service-accounts";
import {
    aNumbers,
    IANumbersState,
    getDefaultANumbersState,
} from "@/store/modules/anumbers/index";
import {
    IAssetsState,
    assets,
    getDefaultAssetsState,
} from "@/store/modules/assets";
import {
    programContents,
    IProgramContentState,
    getDefaultPCState,
} from "@/store/modules/program-contents/index";
import { IRouterState, IRootState } from "./types";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<IRootState>({
    storage: window.localStorage,
    modules: [
        NamespacesModules.CP,
        NamespacesModules.SP,
        NamespacesModules.UserProfile,
        NamespacesModules.ProvidersUsers,
        NamespacesModules.SA,
        NamespacesModules.ANumbers,
        NamespacesModules.Assets,
        NamespacesModules.ProgramContents,
    ],
});

const actions: ActionTree<IRootState, IRootState> = {
    resetRootState({ commit }) {
        commit("resetState");
    },
};

const mutations: MutationTree<IRootState> = {
    resetState(state) {
        Object.assign(state.contentProviders, getDefaultCPState());
        Object.assign(state.userProfile, getDefaultUserState());
        Object.assign(state.serviceProviders, getDefaultSPState());
        Object.assign(state.providersUsers, getDefaultProvidersUsersState());
        Object.assign(state.serviceAccounts, getDefaultSAState());
        Object.assign(state.aNumbers, getDefaultANumbersState());
        Object.assign(state.assets, getDefaultAssetsState());
        Object.assign(state.programContents, getDefaultPCState());
    },
};

export const store: StoreOptions<IRootState> = {
    actions,
    mutations,
    modules: {
        serviceProviders,
        contentProviders,
        userProfile,
        providersUsers,
        serviceAccounts,
        aNumbers,
        assets,
        programContents,
    },
    plugins: [vuexLocal.plugin],
};

export default new Vuex.Store<IRootState>(store);
